import { useContext } from 'react';

import { TimeseriesChartLoadingContext } from '../context/TimeseriesChartLoading.context.js';

export const useTimeseriesLoading = () =>
  useContext(TimeseriesChartLoadingContext);
